import { Editor } from "@tiptap/react";
import { editorTextToParagraphNodes } from "@common/utils/tiptap-paragraphs";

export function replaceTextAsParagraphs(editor: Editor, value: string): void {
  editor.chain().focus().selectAll().insertContent(editorTextToParagraphNodes(value)).run();
}

export function appendTextAsParagraphs(editor: Editor, value: string): void {
  const content = editorTextToParagraphNodes(value);
  if (editor.isEmpty) {
    editor.chain().setContent({ type: "doc", content }).focus("end").run();
  } else {
    editor.chain().focus("end").insertContent(content).run();
  }
}
